<template>
  <div class="vr360-flex-column vr360-app-main__proff-settings" v-if="user">
    <div class="vr360-app-main__proff-settings__ava">
      <div class="vr360-avatar-stub vr360-app-main__proff-settings__ava__img">
        <img class="vr360-avatar-stub" :src="user.avatar | storagePath" alt="">
      </div>
      <p class="vr360-head-h4 vr360-text-white vr360-text-elips">{{user.name}} {{user.surname}}</p>
      <p class="vr360-text-reg vr360-text-white">
        <template v-if="user.streams_count > 0">
          {{user.streams_count | streams}}
        </template>
        <template v-else>
          You havn`t streams
        </template>
      </p>
    </div>

    <div class="vr360-app-main__proff-settings__links">
      <router-link 
        :to="{ name: 'EditProfile' }"
        class="vr360-head-h1 vr360-text-blue vr360-link"
      >Profile</router-link>
      <button type="button"
              class="vr360-head-h1 vr360-text-blue vr360-link"
              @click="logoutUser"
      >Logout</button>
      <!-- <a class="vr360-head-h1 vr360-text-blue vr360-link" href="#">Plans</a> -->
    </div>

    <!-- <div class="vr360-app-main__bottom"> 
      <p class="vr360-text-reg">Invite friends to 2  month of <span class="vr360-head-h4">Premium FREE</span></p>
      <button class="vr360-btn">
        <span>Invite</span>
      </button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MenuProfile",
  methods: {
    ...mapActions({
      showNotification: "showNotification",
      logoutUser: "user/logoutUser"
    })
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    })
  }
};
</script>

<style lang="scss">
</style>
